const findAttributeValue = (node, attribute) => {
	if (!node || node === document) return null;
	const attr = node.attributes && node.attributes.getNamedItem(attribute);
	if (attr) {
		return attr.value;
	}
	return findAttributeValue(node.parentNode, attribute);
};

export default findAttributeValue;
